import { useMutation } from '@tanstack/react-query';
import { UPLOAD_IMAGE } from '@/helpers/query-keys';
import { uploadImage, UploadImageType } from '@/services/qc.service';

export const useUploadImage = (type: UploadImageType) => {
  return useMutation({
    mutationKey: [UPLOAD_IMAGE, type],
    mutationFn: ({
      uuid,
      file,
      token,
    }: {
      uuid: string;
      file: File;
      token?: string | null;
    }) => uploadImage(uuid, file, type, token),
  });
};
